var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurveShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 811,
    viewBox: "0 0 1512 811",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_116)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 811H1512V684.486C1208.42 606.486 984.333 638.11 702.45 695.486C486.281 739.486 268.537 757.486 0 697.486V811Z",
    fill: "#131417"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_65_116",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1512,
    height: 127
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1512 0H0V80C303.581 158 527.667 126.376 809.55 69C1025.72 25 1243.46 7 1512 67V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_65_116)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 811,
    fill: "#131417"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 811,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveShape);
export default __webpack_public_path__ + "static/media/curve-shape.7750c1a9215292a8915d53ca4cc89215.svg";
export { ForwardRef as ReactComponent };